import { createBlueprint as t } from "@made-people/blueprint";
const o = t({
  slots: {
    overlay: "fixed inset-0 z-[60]",
    content: "fixed z-[80]",
    dragHandle: "w-1/3 h-1 flex-shrink-0 cursor-grab active:cursor-grabbing bg-white rounded-full",
    header: "flex justify-between items-center p-5 pb-3 border-b border-black/15",
    headerCloseIcon: "cursor-pointer",
    closeIcon: "absolute top-4 right-4 cursor-pointer z-10"
  },
  variants: {
    header: {
      heading: { header: "" }
    },
    rounded: {
      none: {
        content: ""
      },
      subtle: {
        content: "rounded-t-[10px]"
      },
      medium: {
        content: "rounded-t-[20px]"
      },
      strong: {
        content: "rounded-t-[30px]"
      }
    },
    minHeight: {
      none: {
        content: ""
      },
      "half-viewport": {
        content: "min-h-[50dvh]"
      }
    },
    dragHandle: {
      false: {
        dragHandle: ""
      },
      true: {
        dragHandle: "",
        content: ""
      }
    },
    dimmed: {
      none: {
        overlay: ""
      },
      subtle: {
        overlay: "bg-black/20"
      },
      medium: {
        overlay: "bg-black/40"
      },
      strong: {
        overlay: "bg-black/60"
      }
    },
    background: {
      white: {
        content: "bg-white"
      },
      none: {
        content: ""
      }
    },
    blurred: {
      none: {
        overlay: ""
      },
      subtle: {
        overlay: "backdrop-blur-sm"
      },
      medium: {
        overlay: "backdrop-blur-md"
      },
      strong: {
        overlay: "backdrop-blur-lg"
      }
    },
    direction: {
      top: {
        content: "top-0 left-0 right-0 h-[66%] mb-24",
        dragHandle: "mx-auto mb-4 bottom-0 absolute"
      },
      bottom: {
        content: "bottom-0 left-0 right-0 mt-24",
        dragHandle: "mb-0 mt-4 mx-auto"
      },
      center: {
        content: "top-[auto] left-[auto] bottom-[auto] mt-0 bg-transparent transform-[none] flex justify-center w-full",
        dragHandle: "hidden"
      },
      left: {
        content: "bottom-0 left-0 top-0 h-full",
        dragHandle: "right-0 top-[45%] rotate-90 absolute"
      },
      right: {
        content: "bottom-0 top-0 right-0 h-full",
        dragHandle: "-left-20 xl:-left-30 top-[45%] rotate-90 absolute"
      }
    }
  },
  defaultVariants: {
    blurred: "medium",
    dimmed: "subtle",
    background: "white",
    minHeight: "none"
  }
});
export {
  o as drawerBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
